import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { AppHeader } from '../components/AppHeader';
import { fetchBookingTenant } from '../booking-flow/api';
import { useDocumentTitle } from '../lib/use-document-title';

export const Route = createFileRoute('/book/$slug')({
  component: BookingLayout,
});

function BookingLayout() {
  const { slug } = Route.useParams();
  const tenantQ = useQuery({
    queryKey: ['booking-tenant', slug],
    queryFn: () => fetchBookingTenant(slug),
    staleTime: 60_000,
  });
  useDocumentTitle(tenantQ.data ? `Book with ${tenantQ.data.tenant.name}` : null);
  return (
    <div className="min-h-dvh bg-background">
      <AppHeader
        tenant={
          tenantQ.data
            ? {
                slug: tenantQ.data.tenant.slug,
                name: tenantQ.data.tenant.name,
                timezone: tenantQ.data.tenant.timezone,
              }
            : undefined
        }
      />
      <Outlet />
    </div>
  );
}
